module.exports = __webpack_public_path__ + "img/banner-md.86094afa.png";